import React from 'react';
import Helmet from 'react-helmet'
import Layout from '../../components/Layout'
import Background from '../../components/Background'
import {RichText} from 'prismic-reactjs';
import Link from 'gatsby-link'
import {navigateTo} from 'gatsby-link'
import styled from 'styled-components'
import Grid from 'styled-components-grid'
import Button from '@material-ui/core/Button'
import {
  GridContainer, 
  IntroGridUnit, 
  opacity, 
  SpacedGridUnit, 
  OpacSpacedGridUnit,
  Box
} from '../../components/Styles'
import {Padding} from 'styled-components-spacing'
import Section from '../../components/Section'

const OpacIntroGridUnit = IntroGridUnit.extend`
  ${opacity};
`;

const PageTemplate = ({data}) => {
  const content = data.content.data;
  return (
    <Layout 
      navigationLinks={data.menu.data.body}
      meteoLinks={data.meteo.data}
      pagesUrl={data.allPagesUrl}
      bannerImages={content.header_images}
    >
      <Helmet
        title={content.meta_title}
        meta={[
          { name: 'description', content: content.meta_description }
        ]}
      />
      <Background backgroundImage={content.background}>
        <Padding bottom={4}>
          <GridContainer>
            <Grid horizontalAlign="center">
              <OpacIntroGridUnit>
                <h1>{content.title[0].text}</h1>
                {RichText.render(content.introduction)}
              </OpacIntroGridUnit>
            </Grid>
            {content.body.map(({primary}, index) => (
              <Section primary={primary} index={index} pagesUrl={data.allPagesUrl} />
            ))}
            { content.action && content.action != 'none' && (
              <Grid horizontalAlign="center">
                { content.action == 'prices' ?
                  <Button onClick={() => navigateTo('/tarifs') } variant="contained" color="primary">Tarifs</Button>
                  :
                  <Button onClick={() => navigateTo('/contact') } variant="contained" color="primary">Contact</Button>
                }
              </Grid>
            )}
          </GridContainer>
        </Padding>
      </Background>
    </Layout>
  )
}

export default PageTemplate;

export const query = graphql`
  query PrismicTemplateSubContent ($slug:String!) {
    menu:  prismicDocument(type: {eq: "navigation"}) {
      ...NavigationLinks
    }
    meteo: prismicDocument(type: {eq: "menu_meteo"}) {
      ...MenuMeteo
    }
    allPagesUrl: allSitePage {
      ...PagesUrl
    }
    content: prismicDocument(slugs: {eq: $slug}) {
      slugs
      data {
        meta_description 
        meta_title
        title {
          text
        }
        header_images {
          slideshow_image {
            url
            alt
            xl { url }
            md { url }
            sm { url }
          }
        }
        introduction {
          text
          type
          spans {
            start
            end
            type
          }
        }
        background {
          url
          xl { url }
          md { url }
          sm { url }
        }
        action
        body {
          primary {
            text_content {
              type
              text
              spans {
                start
                end
                type
              }
            }
            link_to_a_content {
              slug
              data {
                title {
                  text
                }
              }
            }
            image {
              dimensions {
                width
                height
              }
              url 
              xl { url }
              md { url }
              sm { url }
            }
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/templates/prismic-page/index.js